import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import type { IconName } from "../../../types";

interface QuickAction {
	id: number;
	title: string;
	description: string;
	icon: IconName;
	color: "primary" | "secondary" | "success" | "warning" | "error";
	action: () => void;
}

const QuickActions: React.FC = () => {
	const navigate = useNavigate();

	const quickActions: QuickAction[] = [
		{
			id: 1,
			title: "Add Property",
			description: "Register new property",
			icon: "Plus",
			color: "primary",
			action: () => navigate("/property-management"),
		},
		{
			id: 2,
			title: "Create Lease",
			description: "New lease agreement",
			icon: "FileText",
			color: "success",
			action: () => navigate("/lease-management"),
		},
		{
			id: 3,
			title: "Manage Users",
			description: "Add users & assign roles",
			icon: "UserPlus",
			color: "warning",
			action: () => navigate("/user-management"),
		},
		{
			id: 4,
			title: "Maintenance",
			description: "Assign work order",
			icon: "Wrench",
			color: "error",
			action: () => navigate("/maintenance-management"),
		},
		{
			id: 5,
			title: "Announcements",
			description: "Create announcement",
			icon: "Megaphone",
			color: "primary",
			action: () => navigate("/announcement-management"),
		},
	];

	return (
		<div className="bg-card border border-border rounded-lg p-6 card-shadow flex flex-col h-full">
			<h3 className="text-lg font-semibold text-foreground mb-4 flex-shrink-0">
				Quick Actions
			</h3>

			<div className="flex-1 flex flex-col justify-start min-h-0">
				<div className="space-y-2">
					{quickActions.map((action) => (
						<Button
							key={action.id}
							variant="outline"
							onClick={action.action}
							className="w-full h-auto py-2 px-3 flex items-center gap-2.5 hover:bg-muted/50 justify-start"
						>
							<div
								className={`flex-shrink-0 p-1.5 rounded-lg ${
									action.color === "primary"
										? "bg-primary/10 text-primary"
										: action.color === "success"
										? "bg-success/10 text-success"
										: action.color === "warning"
										? "bg-warning/10 text-warning"
										: "bg-error/10 text-error"
								}`}
							>
								<Icon name={action.icon} size={18} />
							</div>
							<div className="flex-1 min-w-0 text-left">
								<p className="text-sm font-medium text-foreground truncate">
									{action.title}
								</p>
								<p className="text-xs text-muted-foreground truncate">
									{action.description}
								</p>
							</div>
						</Button>
					))}
				</div>
			</div>
		</div>
	);
};

export default QuickActions;
